import { Tooltip } from 'antd';
import { routesMap } from 'app/Router';
import { JobItem } from 'domains/workspaceDomain';
import { useHistory } from 'react-router-dom';

type Props = {
  data: Partial<JobItem>;
  disabled?: boolean;
};

export const JobNum = ({ data, disabled }: Props) => {
  const history = useHistory();
  const hideDisabled = true;
  const jumpJobDetail = () => {
    if (!disabled) {
      history.push(`${routesMap.workspace.path}/jobs/${data.id}`);
    }
  };

  return (
    <span
      className={`workspace-item-job-num ${
        hideDisabled ? 'workspace-item-job-num-disabled' : ''
      }`}
      onClick={(e) => {
        if (e.metaKey) {
          if (!disabled) {
            jumpJobDetail();
          }
        }
      }}
    >
      <Tooltip title={data.isQuote ? data.quoteId : ''}>
        {data.isQuote
          ? (data.quoteId || '').slice(0, 12) +
            `${(data.quoteId || '').length > 12 ? '...' : ''}`
          : data.revisionJobId
          ? data.revisionJobId
          : data.id}
      </Tooltip>
    </span>
  );
};
